import React from "react";
import InputText from "../../../../components/staff/InputText";
import { useEditParticipantForm } from "../hooks/useEditParticipantForm";

export default function CcEmailSection (): React.ReactElement {
  const {
    ccName,
    ccEmail,
    paymentFieldsDisabled,
    setCcName,
    setCcEmail,
  } = useEditParticipantForm();

  return (
    <div className="flex flex-col gap-4">
      <h3 className="w-full text-secondary">
        CC Email Information
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <InputText
          title="Name"
          value={ccName}
          onChange={setCcName}
          disabled={paymentFieldsDisabled}
        />
        <InputText
          title="Email"
          value={ccEmail}
          onChange={setCcEmail}
          disabled={paymentFieldsDisabled}
        />
      </div>
    </div>
  );
}
